import { Box } from '@mui/material';
import { useContext } from 'react';
import Joyride from 'react-joyride'
import { ToolContext } from '../../../core/context/ToolContext';
import { rqx } from '../../../core/request/API';
import { env } from '../../../core/Env';


export const TourMsg = () => {
    const { ubr_state, tool_state } = useContext(ToolContext)
    const { tour, tourData } = ubr_state;
    const Steps = [
        {
            target: '.dashboard',
            title: "Dashboard",
            content: 'Your transaction summary.',
            disableBeacon: true,
            placement: "right"
        },
        {
            target: '.campaign',
            title: "Campaign",
            content: 'Create any campaigns you can use to promote your products and services.',
            disableBeacon: true,
            placement: "right"
        },
        {
            target: '.delivery',
            title: "Delivery",
            content: 'List of sales transaction of tour product and services.',
            disableBeacon: true,
            placement: "right"
        },
        {
            target: '.report',
            title: "Report",
            content: 'Reports of your product and services transactions.',
            disableBeacon: true,
            placement: "right"
        },
        {
            target: '.tool-categories',
            title: "Tool Categories",
            content: 'This is my awesome feature!',
            disableBeacon: true,
            placement: "right"
        },
        {
            target: '.personal',
            title: "Personal ",
            content: 'Switch to Business to enjoy its benefits to grow your career. Experience seamless switching between HRC to Your Personal Acccount',
            disableBeacon: true,
            placement: "bottom"
        },
        {
            target: '.business',
            title: "Business",
            content: 'Switch to Business to enjoy its benefits to grow your business.',
            disableBeacon: true,
            placement: "bottom"
        },
        {
            target: '.mytools',
            title: "My Tools",
            content: 'Switch to all Business tools that you availed and will be availed.',
            disableBeacon: true,
            placement: "bottom"
        },

    ];
    const Tourstyle = () => {
        const tourcss = {
            options: {
                zIndex: 1202,
                // width: view === '' ? '317px' : 'auto',
                borderRadius: '15px',
                width: '317px'

            },
            buttonClose: {
                display: 'none',
            },
            buttonNext: {
                fontFamily: "Inter",
                fontWeight: 500,
                backgroundColor: "#0070EF",
                padding: "8px",
                fontSize: "12px !important",
                borderRadius: "15px",
                color: "#fff",
                cursor: "pointer",
                textAlign: "center",
                width: "80px",
                height: '33px'
            },
            buttonSkip: {
                fontFamily: "Inter",
                fontWeight: 500,
                padding: "8px",
                fontSize: "12px !important",
                color: "#A3A3A3",
                cursor: "pointer",
                textAlign: "center",
                width: "80px",
                height: '33px',
                left: 0,
                marginRight: '2px',
                float: 'right'
            },
            tooltip: {
                minHeight: '140px',
                height: '100%',
                borderRadius: '15px',
            },
            tooltipFooter: {
                marginTop: 0,
                padding: '0px 16px 0px 16px',
                minHeight: '40px',
            },
            tooltipContent: {
                height: '100%',
                padding: '10px'
            },
            overlay: {
                height: '100%'
            },
        }
        return tourcss
    }
    const asyncTour = async (e) => {
        if (e.action === 'skip' || e.action === 'reset' || e.action === 'close') {
            const data = await rqx.post(`<<global>>/${env() === 'local' ? 'dev' : env()}/personalization/create`,
                {
                    user_id: parseInt(tool_state.userId.data),
                    tool_id: parseInt(process.env.REACT_APP_TID_BIZ),
                    feature_name: 'hrcPrsn',
                    personalization: [{ sf_name: 'hrcPrsn', status: 1 }]
                })
                if (data.msg === 'success') {
                    tourData.set([{
                        active: 1,
                        created_by: parseInt(tool_state.userId.data),
                        feature_name: "hrcPrsn",
                        personalization: "[{\"status\": 1, \"sf_name\": \"hrcPrsn\"}]",
                        tool_id: parseInt(process.env.REACT_APP_TID_BIZ),
                    }])
                }
            }
       
    }

    return (
        <Box>
            <Joyride styles={Tourstyle()}
                run={tour.data}
                steps={Steps}
                showSkipButton={true}
                continuous={true}
                locale={{ skip: 'Close', last: 'Got it' }}
                hideBackButton={true}
                spotlightPadding={1}
                hideCloseButton={true}
                disableOverlayClose={true}
                disableCloseOnEsc={true}
                disableScrollParentFix={true}
                disableScrolling={true}
                callback={(e)=>asyncTour(e)}
            />
        </Box>
    )
}
